// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._9bdsgpT8ROvAG6QxDhTJt{height:100vh;width:100vw;position:fixed;left:0;top:0;z-index:100}.UNIkXTZOoC9fL-oWBeC5_{height:100%;width:100%;background-color:#000;opacity:0;transition:opacity 600ms}._3sWEaOK1TJWNbuXBcDxspA{display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity 600ms}._1SjnGP0PSsygLio3ytMWsH{max-width:600px;background-color:#fff}._279OA8Sep0r4OqoondZ0ud{margin-bottom:20px}._3KMBVfU8Q9PIQO31hggIv6{height:30px;width:30px}", ""]);
// Exports
exports.locals = {
	"container": "_9bdsgpT8ROvAG6QxDhTJt",
	"overlay": "UNIkXTZOoC9fL-oWBeC5_",
	"content": "_3sWEaOK1TJWNbuXBcDxspA",
	"modal": "_1SjnGP0PSsygLio3ytMWsH",
	"spacer": "_279OA8Sep0r4OqoondZ0ud",
	"infoIconSvg": "_3KMBVfU8Q9PIQO31hggIv6"
};
module.exports = exports;
